import { isSSR } from "@shared/utils/fullscriptEnv/fullscriptEnv";

export const getLocalData = (key: string): any => {
  if (isSSR() || !localStorage) return null;

  const data = localStorage.getItem(key);
  if (data === null) return null;

  try {
    return JSON.parse(data);
  } catch {
    return data;
  }
};

export const setLocalData = (key: string, data: any): void => {
  if (isSSR() || !localStorage) return;

  try {
    localStorage.setItem(key, JSON.stringify(data));
  } catch (error) {
    localStorage.setItem(key, data);
  }
};

export const removeLocalData = (key: string): void => {
  if (isSSR() || !localStorage) return;

  localStorage.removeItem(key);
};

export const getSessionData = (key: string): any => {
  if (isSSR() || !sessionStorage) return null;

  const data = sessionStorage.getItem(key);
  if (data === null) return null;

  try {
    return JSON.parse(data);
  } catch {
    return data;
  }
};

export const setSessionData = (key: string, data: any): void => {
  if (isSSR() || !sessionStorage) return;

  try {
    sessionStorage.setItem(key, JSON.stringify(data));
  } catch (error) {
    sessionStorage.setItem(key, data);
  }
};

export const removeSessionData = (key: string): void => {
  if (isSSR() || !sessionStorage) return;

  sessionStorage.removeItem(key);
};
